import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, BASE_URL_PREBID } from "../../config/axios";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { ToastContainer, toast } from "react-toastify";
import { formatCurrencyIndian, formatRoundoffCrores, handleErrorToast, getProgressColor, formatRoundoff2D, customSortByKey } from "../custom.jsx";
import { Eye, CircularGrid, DeleteDustbin, Sort, Filter, SearchBig, Attachment, Truckbody, Tires, Road } from "../AllSvg.jsx";
import { formattedDateLong, formattedDateNoYear } from "../Date.jsx";
import { UploadProjectsBulk } from "../BulkModals";
import { PieChart, Pie, Cell } from 'recharts';
import StatusBar from "../StatusBar/Statusbar.jsx"
import StatsBar from "../Stats.jsx";
import Select from "react-select";
import Projectname from "../Projectname.jsx";
import UpdateProjectDetaiils from "../Modals/UpdateProjectDetails.jsx";

const DeleteProjectDocuments = ({ id, getJobappdata }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      console.log("Delete Expense Detail Api");
      let res = await axios.delete(
        `${BASE_URL}/project/projectupdate/${id.pr_code}/`
      );

      if (res.status === 200) {
        await getJobappdata("null");
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are You Sure, You want to Delete
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          <br />
          {id.prebid_prcode} - {id.project_name}

          <div className="button-models">

            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-cancel"
            >
              Delete
            </button>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteProjectDetails = ({ i, getProjects, prProjects }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      console.log("Delete Expense Detail Api");
      let res = await axios.delete(
        `${BASE_URL}/project/project/${i.pr_code}/`
      );

      if (res.status === 200) {
        await getProjects("null");
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err)
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        <Modal.Header closeButton>
          <Modal.Title>Delete Project</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are You Sure, You want to Delete the Project:
          <br />

          <div className="flex-row">
            <label
              htmlFor="project_name"
              className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
            >
              Project -
            </label>
            <div className="form-labels announce-date font-size-heading padding-lefttt">
              {i.prebid_prcode}
            </div>
          </div>

          <div className="flex-row">
            <label
              htmlFor="project_name"
              className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
            >
              Project Name -
            </label>
            <div className="form-labels announce-date font-size-heading padding-lefttt">
              {i.project_short_name ? i.project_short_name : i.project_name}
            </div>
          </div>

          {/* <div className="flex-row">
            <label
              htmlFor="project_name"
              className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
            >
              ID
            </label>
            <div className="form-labels announce-date font-size-heading padding-lefttt">
              {i.pr_code}
            </div>
          </div> */}

          {/* <div className="flex-row">
            <label
              htmlFor="project_name"
              className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
            >
              Cost (in cr) -
            </label>
            <div className="form-labels announce-date font-size-heading padding-lefttt">
              <td className="table-body-text">{formatRoundoffCrores(i.cost)}</td>
            </div>
          </div> */}

          <div className="button-models">
            <button
              onClick={handleFormSubmitDelete}
              className="model-button model-button-delete"
            >
              Delete
            </button>
          </div>

        </Modal.Body>
      </Modal>
    </>
  );
};


// const AllProjectDetails = () => { 

//   const [allProjectssData, setAllProjectsData] = useState([]);
//   const [sortedData, setSortedData] = useState([]);
//   const [search1, setSearch1] = useState("");

//   const [sorting, setSorting] = useState("desc_pr"); // Default to "asc_pr"
//   const [prProjects, setPrProjects] = useState("false");
//   const [buffer, setBuffering] = useState(true); //buffering logic

//   const [toggleStatus, setToggleStatus] = useState("inprogress");

//   const handleSortChange = (e) => setSorting(e.target.value);
//   const handleStatusChange = (e) => setToggleStatus(e.target.value);


//   useEffect(() => {
//     const compareFunction = (a, b) => {
//       const valA = a.prebid_prcode || ''; // Replace null with an empty string
//       const valB = b.prebid_prcode || ''; // Replace null with an empty string
//       const valM = a.project_short_name || ''; // Replace null with an empty string
//       const valN = b.project_short_name || ''; // Replace null with an empty string

//       if (sorting === "asc_pr") {
//         return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });
//       } else if (sorting === "desc_pr") {
//         return valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
//       } else if (sorting === "asc_short_name") {
//         // Ascending order
//         if (!valM && valN) return 1; // Move null/empty values to the end
//         if (valM && !valN) return -1; // Keep non-null values before null
//         return valM.localeCompare(valN, undefined, { sensitivity: 'base' });
//       }
//       else if (sorting === "desc_short_name") {
//         // Descending order
//         if (!valM && valN) return -1; // Move null/empty values to the end
//         if (valM && !valN) return 1; // Keep non-null values before null
//         return valN.localeCompare(valM, undefined, { sensitivity: 'base' });
//       }
//     };

//     const sortedData = [...allProjectssData].sort(compareFunction);
//     setSortedData(sortedData);
//   }, [sorting, allProjectssData]);




//   const emp_code = sessionStorage.getItem('employee_id');
//   const role = sessionStorage.getItem('role');
//   const pr_project = sessionStorage.getItem('pr_project');

//   const getProjectData = async () => {
//     setBuffering(true); //buffering logic // Start Buffering
//     try {
//       const res = await axios.get(
//         `${BASE_URL_PREBID}/project/projectfilterbyprojectstatus/${toggleStatus}/${role === "HOD" ? "null" : emp_code}/null/null/`
//       );
//       setAllProjectsData(res.data);
//     } catch (err) {
//       handleErrorToast(err)
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };

//   useEffect(() => {
//     getProjectData();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [toggleStatus]);


//   const navigate = useNavigate();

//   const currentUrl = window.location.href;
//   const urlParts = currentUrl.split("/");
//   const associated = true;
//   const ViewAllProjectDetails = (projectID) => {
//     navigate(`/${urlParts[3]}/projectDetailsPage/`, {
//       state: { projectID, associated },
//     });
//   };

//   const handleSearch = () => {
//     let filteredingData = allProjectssData;

//     if (search1 !== "") {
//       const lowercasesearch1 = search1?.toString().toLowerCase();
//       filteredingData = filteredingData.filter(
//         (employee) => {
//           const codeMatch = employee?.prebid_prcode
//             ?.toString().toLowerCase()
//             .includes(lowercasesearch1.toLowerCase());

//           const projectMatch = employee?.project_name
//             ?.toString().toLowerCase()
//             .includes(lowercasesearch1.toLowerCase());

//           const shortProjectMatch = employee?.project_short_name
//             ?.toString().toLowerCase()
//             .includes(lowercasesearch1.toLowerCase());
//           return codeMatch || projectMatch || shortProjectMatch;
//         }
//       );
//     }
//     setSortedData(filteredingData);
//   };

//   useEffect(() => {
//     handleSearch();
//   }, [search1]);

//   return (
//     <>

//       <Dashboardnavbarcopy url="Projects Management" name={"Associated Projects"} />

//       <div className="content-tabs">
//         <div className="attendance-subcont">
//           <div className="field-cont">

//             {pr_project === "true" ?
//               <div title="Project Filter " className="field-cont-div ">
//                 <CircularGrid />

//                 <select
//                   value={prProjects}
//                   onChange={(e) => setPrProjects(e.target.value)}
//                   className={`attendance-input-field width-15vw`}
//                 >
//                   <option value="null">Select Project Type</option>
//                   <option value="false">Projects</option>
//                   <option value="true">PR Projects</option>

//                 </select>
//                 <hr className="field-cont-hr" />

//               </div>
//               : null}

//             <div title="Sort Filter" className="field-cont-div">
//               <Sort />
//               <select
//                 className="attendance-input-field width-15vw   date-field"
//                 type="text"
//                 value={sorting}
//                 onChange={handleSortChange}
//               >
//                 <option value="asc_pr">Asc. Project Code</option>
//                 <option value="desc_pr">Desc. Project Code</option>
//                 <option value="asc_short_name">Asc. Project Name</option>
//                 <option value="desc_short_name">Desc. Project Name</option>
//               </select>
//               <hr className="field-cont-hr" />
//             </div>

//             <div title="Status Filter" className="field-cont-div">
//               <Filter />
//               <select
//                 className="attendance-input-field width-15vw   date-field"
//                 value={toggleStatus}
//                 onChange={handleStatusChange}
//               >
//                 <option value="null">All Projects</option>
//                 <option value="inprogress">OnGoing</option>
//                 <option value="completed">Completed</option>
//               </select>
//               <hr className="field-cont-hr" />
//             </div>

//             <div className="field-cont-div">
//               <SearchBig />
//               <input
//                 className="attendance-input-field width-15vw"
//                 placeholder="BY Project Code/Name"
//                 type="text"
//                 value={search1}
//                 onChange={(e) => setSearch1(e.target.value)}
//               />
//               <hr className="field-cont-hr" />
//             </div>



//           </div>
//           <div className="btn-cont">
//             <UploadProjectsBulk getProject={getProjectData} />
//           </div>
//         </div>

//         <div className="attendance-box">
//           <div className="datagrid-container">
//             <div className="custom-table-background height-73vh" style={{ padding: "20px 0 0 0" }}>
//               <div className="table-heading-flex">
//                 {/* <div className="repo-heading font-size-heading font-weight500">All Projects</div> */}
//               </div>
//               {/* <div className="table-heading-flex">
//                 <div className="bloc-tabs-with-white-bg bloc-tabs-with-lesswhite-bg">
//                   {["All", "pending", "inprogress", "completed", "hold", "cancelled"].map(
//                     (status) => (
//                       <button
//                         key={status}
//                         className={
//                           toggleState === (status === "All" ? "null" : status)
//                             ? "dashboardcomponent-tabs dashboardcomponent-active-tabs"
//                             : "dashboardcomponent-tabs white-tab"
//                         }
//                         onClick={() =>
//                           setToggleState(status === "All" ? "null" : status)
//                         }
//                       >
//                         {status.charAt(0).toUpperCase() + status.slice(1)}
//                       </button>
//                     )
//                   )}
//                 </div>
//               </div> */}

//               <div className="table-box scroll-container-table">
//                 <table className="custom-table">
//                   <thead className="table-heading">
//                     <tr className="custom-table-head-trr">
//                       <th className="table-heading-text justify-center">Sr.</th>
//                       <th className="table-heading-text text-center">Project Code</th>
//                       <th className="table-heading-text width-5vw">Project Name</th>
//                       <th className="table-heading-text ">Cost (in cr)</th>
//                       <th className="table-heading-text ">Concern Person</th>
//                       <th className="table-heading-text ">Portal Submission Date</th>
//                       <th className="table-heading-text ">Tender ID</th>
//                       <th className="table-heading-text ">Remark</th>
//                       <th className="table-heading-text text-center">Project Link</th>
//                       <th className="table-heading-text text-center">Client Details

//                         <td className="padding-bottom-5px " style={{ display: "flex", justifyContent: "space-around", paddingTop: "20px" }}>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">Client Name</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                             <hr className="field-cont-hr" />
//                           </th>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">WO Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                             <hr className="field-cont-hr" />
//                           </th>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">Target Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                             <hr className="field-cont-hr" />
//                           </th>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">Due Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                             <hr className="field-cont-hr" />
//                           </th>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">Status</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                             <hr className="field-cont-hr" />
//                           </th>
//                           <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">Progress</td>
//                         </td>
//                       </th>
//                       <th className="table-heading-text text-right align-right">Action</th>
//                     </tr>
//                     {/* <tr className="custom-table-head-tddd-nb font-size-label font-weight500"  >
//                         <td className="padding-bottom-5px " style={{ display: "flex", justifyContent: "space-around" }}>
//                           <td className="padding-bottom-5px width-5vw text-center">Client Name</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                           <td className="padding-bottom-5px width-10vw text-center">Work Order Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                           <td className="padding-bottom-5px width-5vw text-center">Target Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                           <td className="padding-bottom-5px width-5vw text-center">Due Date</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                           <td className="padding-bottom-5px width-5vw text-center">Status</td>
//                           <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                           <td className="padding-bottom-5px width-5vw text-center">Progress</td>
//                         </td>
//                       </tr> */}
//                   </thead>


//                   {buffer ? <div className="loader">
//                     <div className="truckWrapper">
//                       <div className="truckBody">
//                         <Truckbody />
//                       </div>
//                       <div class="truckTires">
//                         <Tires />
//                         <Tires />
//                       </div>
//                       <div className="road"></div>
//                       <Road />
//                     </div>
//                   </div> :

//                     <tbody>
//                       {sortedData
//                         .map((i, index) => (
//                           <React.Fragment key={index}>
//                             <tr className="tr-border-bottom">
//                               <td colSpan="8"></td>
//                             </tr>
//                             <tr className="custom-table-head-tddd font-size-label font-weight500">
//                               <td className="table-body-text">{index + 1}</td>
//                               <td className="table-body-text">{i.prebid_prcode}</td>
//                               <td className="table-body-text word-wrap-10vw">{i.project_short_name}</td>

//                               <td className="table-body-text">{formatRoundoffCrores(i.cost)}</td>
//                               {/* <td className="table-body-text">{i.name_of_client}</td> */}
//                               <td className="table-body-text">
//                                 {i.concern_person_name === "null"
//                                   ? "-"
//                                   : i.concern_person_name}
//                               </td>
//                               <td className="table-body-text">
//                                 {i.portal_submission_date === null
//                                   ? ""
//                                   : formattedDateLong(i.portal_submission_date)}
//                               </td>
//                               <td className="table-body-text">{i.tender_id}</td>

//                               <td className="table-body-text">
//                                 {i.remark === "null" ? "-" : i.remark}
//                               </td>
//                               <td className="table-body-text align-center">
//                                 {i.link ?
//                                   <>
//                                     {/* <a href={i.link} target="blank" className="document-download-button  width-5vw  width-5vw">
//                                       Link
//                                     </a> */}
//                                     <a href={i.link} target="blank" className="width-5vw">
//                                       <Attachment />
//                                     </a>
//                                   </>
//                                   :
//                                   <>-</>
//                                 }
//                               </td>
//                               {prProjects !== "null" ? (
//                                 <td className="table-body-text">
//                                   {prProjects === "false" && i.pr_project_false_clients?.length > 0 ? (
//                                     <div className="employee-card-image">
//                                       <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                         {/* <thead>
//                                           <tr className="">
//                                             <td className="padding-bottom-5px">Client Name</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Work Order Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Target Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Due Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Status</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Progress</td>
//                                           </tr>
//                                         </thead> */}
//                                         <tbody>
//                                           {i.pr_project_false_clients.map((clientdata) => (
//                                             <tr key={clientdata.id} style={{ display: "flex", justifyContent: "space-around" }}>
//                                               <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{clientdata.client_names}</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                 <hr className="field-cont-hr" />
//                                               </th>
//                                               <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.wo_date)}</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                 <hr className="field-cont-hr" />
//                                               </th>
//                                               <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.target_date)}</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                 <hr className="field-cont-hr" />
//                                               </th>
//                                               <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.due_date)}</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                 <hr className="field-cont-hr" />
//                                               </th>
//                                               <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center form-text-trasformation-uppercase">{clientdata.status}</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                 <hr className="field-cont-hr" />
//                                               </th>
//                                               <td className="padding-bottom-5px word-wrap-5vw text-center">
//                                                 <div className="align-center" >
//                                                   <div className='justify-between' style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//                                                     {/* Percent */}
//                                                     <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>{formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%</span>
//                                                   </div>
//                                                   <div style={{
//                                                     width: '100%',
//                                                     height: '5px',
//                                                     backgroundColor: '#EFEFEF',
//                                                     borderRadius: '5px',
//                                                     position: 'relative',
//                                                     border: '1px solid black',
//                                                   }}>
//                                                     <div style={{
//                                                       width: `${formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%`,
//                                                       height: '100%',
//                                                       backgroundColor: getProgressColor(clientdata.workstage_progress?.progress_percentage),
//                                                       borderRadius: '15px',
//                                                       position: 'absolute',
//                                                       top: 0,
//                                                       left: 0,
//                                                     }} />
//                                                   </div>
//                                                 </div>
//                                               </td>
//                                             </tr>
//                                           ))}
//                                         </tbody>
//                                       </table>
//                                     </div>
//                                   ) : prProjects === "true" && i.pr_project_true_clients?.length > 0 ? (
//                                     <div className="employee-card-image">
//                                       <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                         {/* <thead>
//                                           <tr className="">
//                                             <td className="padding-bottom-5px">Client Name</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Work Order Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Target Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Due Date</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Status</td>
//                                             <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                             <td className="padding-bottom-5px">Progress</td>
//                                           </tr>
//                                         </thead> */}
//                                         <tbody>
//                                           {i.pr_project_true_clients
//                                             .sort((a, b) => a.created_at - b.created_at)
//                                             ?.map((clientdata, clientdataindex) => (
//                                               <tr className="table-row-highlight-green" key={clientdata.id} style={{ display: "flex", justifyContent: "space-around" }}>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">PR-{clientdataindex + 1} {clientdata.client_names}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.wo_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.target_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.due_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center form-text-trasformation-uppercase">{clientdata.status}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw text-center">
//                                                   <div style={{ margin: '5px 0px' }} >
//                                                     <div className='justify-between' style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//                                                       {/* Percent */}
//                                                       <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>{formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%</span>
//                                                     </div>
//                                                     <div style={{
//                                                       width: '100%',
//                                                       height: '5px',
//                                                       backgroundColor: '#EFEFEF',
//                                                       borderRadius: '5px',
//                                                       position: 'relative',
//                                                       border: '1px solid black',
//                                                     }}>
//                                                       <div style={{
//                                                         width: `${(clientdata.workstage_progress?.progress_percentage)}%`,
//                                                         height: '100%',
//                                                         backgroundColor: getProgressColor(clientdata.workstage_progress?.progress_percentage),
//                                                         borderRadius: '15px',
//                                                         position: 'absolute',
//                                                         top: 0,
//                                                         left: 0,
//                                                       }} />
//                                                     </div>
//                                                   </div>
//                                                 </td>
//                                               </tr>
//                                             ))}
//                                         </tbody>
//                                       </table>
//                                     </div>
//                                   ) : (
//                                     <div className="align-center ">
//                                       <p className="text-center">-</p>
//                                     </div>
//                                   )}
//                                 </td>)
//                                 : (
//                                   <td className="table-body-text">
//                                     {i.pr_project_false_clients?.length > 0 ? (
//                                       <div className="employee-card-image">
//                                         <table style={{ borderCollapse: "collapse", width: "100%" }}>
//                                           {/* <thead>
//                                             <tr className="">
//                                               <td className="padding-bottom-5px">Client Name</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                               <td className="padding-bottom-5px">Work Order Date</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                               <td className="padding-bottom-5px">Target Date</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                               <td className="padding-bottom-5px">Due Date</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                               <td className="padding-bottom-5px">Status</td>
//                                               <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                         <hr className="field-cont-hr" />
//                                                     </th>
//                                               <td className="padding-bottom-5px">Progress</td>
//                                             </tr>
//                                           </thead> */}
//                                           <tbody>
//                                             {i.pr_project_false_clients?.map((clientdata) => (
//                                               <tr key={clientdata.id} style={{ display: "flex", justifyContent: "space-around" }}>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{clientdata.client_names}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.wo_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.target_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.due_date)}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center form-text-trasformation-uppercase">{clientdata.status}</td>
//                                                 <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                   <hr className="field-cont-hr" />
//                                                 </th>
//                                                 <td className="padding-bottom-5px word-wrap-5vw text-center">
//                                                   <div style={{ margin: '5px 0px' }} >
//                                                     <div className='justify-between' style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//                                                       {/* Percent */}
//                                                       <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>{formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%</span>
//                                                     </div>
//                                                     <div style={{
//                                                       width: '100%',
//                                                       height: '5px',
//                                                       backgroundColor: '#EFEFEF',
//                                                       borderRadius: '5px',
//                                                       position: 'relative',
//                                                       border: '1px solid black',
//                                                     }}>
//                                                       <div style={{
//                                                         width: `${formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%`,
//                                                         height: '100%',
//                                                         backgroundColor: getProgressColor(clientdata.workstage_progress?.progress_percentage),
//                                                         borderRadius: '15px',
//                                                         position: 'absolute',
//                                                         top: 0,
//                                                         left: 0,
//                                                       }} />
//                                                     </div>
//                                                   </div>
//                                                 </td>
//                                               </tr>
//                                             ))}
//                                             {i.pr_project_true_clients.sort((a, b) => a.created_at - b.created_at)
//                                               ?.map((clientdata, clientdataindex) => (
//                                                 <tr className="table-row-highlight-green"
//                                                   key={clientdata.id} style={{ display: "flex", justifyContent: "space-around" }}>
//                                                   <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">PR-{clientdataindex + 1} {clientdata.client_names}</td>
//                                                   <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                     <hr className="field-cont-hr" />
//                                                   </th>
//                                                   <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.wo_date)}</td>
//                                                   <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                     <hr className="field-cont-hr" />
//                                                   </th>
//                                                   <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.target_date)}</td>
//                                                   <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                     <hr className="field-cont-hr" />
//                                                   </th>
//                                                   <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">{formattedDateNoYear(clientdata.due_date)}</td>
//                                                   <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                     <hr className="field-cont-hr" />
//                                                   </th>
//                                                   <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center form-text-trasformation-uppercase">{clientdata.status}</td>
//                                                   <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
//                                                     <hr className="field-cont-hr" />
//                                                   </th>
//                                                   <td className="padding-bottom-5px word-wrap-5vw text-center">
//                                                     <div style={{ margin: '5px 0px' }}>
//                                                       <div className='justify-between' style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
//                                                         {/* Percent */}
//                                                         <span style={{ marginLeft: '10px', fontWeight: 'normal' }}>{formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%</span>
//                                                       </div>
//                                                       <div style={{
//                                                         width: '100%',
//                                                         height: '5px',
//                                                         backgroundColor: '#EFEFEF',
//                                                         borderRadius: '5px',
//                                                         position: 'relative',
//                                                         border: '1px solid black',
//                                                       }}>
//                                                         <div style={{
//                                                           width: `${formatRoundoff2D(clientdata.workstage_progress?.progress_percentage)}%`,
//                                                           height: '100%',
//                                                           backgroundColor: getProgressColor(clientdata.workstage_progress?.progress_percentage),
//                                                           borderRadius: '15px',
//                                                           position: 'absolute',
//                                                           top: 0,
//                                                           left: 0,
//                                                         }} />
//                                                       </div>
//                                                     </div>
//                                                   </td>
//                                                 </tr>
//                                               ))}
//                                           </tbody>
//                                         </table>
//                                       </div>

//                                     ) : (
//                                       <div className="align-center ">
//                                         <p className="text-center">-</p>
//                                       </div>
//                                     )}
//                                   </td>)}
//                               <td className="text-end align-end flex-row-ar">

//                                 <button title="View Project Detail Page" className="" onClick={(e) => ViewAllProjectDetails(i.pr_code)}>
//                                   <Eye />
//                                 </button>
//                                 {role === 'HOD' ? <DeleteProjectDetails i={i} getProjects={getProjectData} prProjects={prProjects} /> : null}

//                               </td>


//                             </tr>
//                           </React.Fragment>
//                         ))}
//                     </tbody>
//                   }
//                 </table>
//               </div>

//             </div>
//           </div>
//         </div>
//       </div >
//     </>
//   );
// };

// export default AllProjectDetails;

const AllProjectDetails = () => {
  const [allProjectssData, setAllProjectsData] = useState({})
  const [sortedData, setSortedData] = useState([])
  const [search1, setSearch1] = useState("")
  const [sorting, setSorting] = useState("desc_pr")
  const [prProjects, setPrProjects] = useState("false")
  const [buffer, setBuffering] = useState(true)
  const [toggleStatus, setToggleStatus] = useState("inprogress")
  const [resultData, setResultdata] = useState("");
  const [minCost, setMinCost] = useState("null");
  const [maxCost, setMaxCost] = useState("null");
  const [project, SetProject] = useState("null");
  // const [employeeRole, setEmployeeRole] = useState(null);
  // const [roleList, setRoleList] = useState([]);

  // const getRoleData = async () => {
  //   try {
  //     const response = await axios.get(`${BASE_URL_PREBID}/siteproject/rolebysubcompany/`);
  //     setRoleList(response.data);
  //   } catch (error) {
  //     console.error(error);

  //   }
  // }

  // const roleOption = [
  //   ...roleList.map((i) => ({
  //     value: i.role_name,
  //     label: i.role_name,
  //   })),
  // ];



  // const handleRoleChange = (option) => {
  //   if (!option) {
  //     setEmployeeRole("null")
  //   }
  //   else {
  //     setEmployeeRole(option.value);
  //   }
  // }


  // useEffect(() => {
  //   getRoleData();
  // }, []);



  // StatusBar related states
  const [projectStats, setProjectStats] = useState({
    total_projects: 0,
    completed: 0,
    pending: 0,
    in_progress: 0,
    hold: 0,
    cancelled: 0,
  })
  const [statsLoading, setStatsLoading] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const tableRef = useRef(null);
  const department_id = sessionStorage.getItem("departmentid");


  const handleSortChange = (e) => setSorting(e.target.value)
  const handleStatusChange = (e) => setToggleStatus(e.target.value)

  // *****************************************paGINATION fUNCTIONALITY**********************************************************************
  const itemsPerPage = 100; // Fixed items per page
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    // Scroll to top of table when page changes
    if (tableRef && tableRef.current) {
      tableRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const [allEmployeeData, setAllEmployeeData] = useState([]);
  const getEmployeeDetails = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/ourcompanysdep/${department_id}/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");
      setAllEmployeeData(sortedList);
    } catch (err) {
      alert(err.message);
    }
  };


  useEffect(() => {
    const newTotalPages = Math.ceil(resultData / itemsPerPage);
    setTotalPages(newTotalPages);
  }, [resultData]);

  const renderPaginationButtons = () => {
    const buttons = [];

    // Always show first page
    buttons.push(
      <button
        key="first"
        className={`pagination-button ${currentPage === 1 ? "active" : ""}`}
        onClick={() => handlePageChange(1)}>
        1
      </button>
    );

    if (totalPages > 7) {
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      if (currentPage <= 3) {
        // Near start, show 2,3,4
        startPage = 2;
        endPage = 4;
      } else if (currentPage >= totalPages - 2) {
        // Near end, show last 3 pages before the final page
        startPage = totalPages - 3;
        endPage = totalPages - 1;
      }

      // Show ellipsis before middle range if needed
      if (startPage > 2) {
        buttons.push(
          <span key="ellipsis1" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      // Add middle range
      for (let i = startPage; i <= endPage; i++) {
        buttons.push(
          <button
            key={i}
            className={`pagination-button ${currentPage === i ? "active" : ""}`}
            onClick={() => handlePageChange(i)}>
            {i}
          </button>
        );
      }

      // Show ellipsis after middle range if needed
      if (endPage < totalPages - 1) {
        buttons.push(
          <span key="ellipsis2" className="pagination-ellipsis">
            ...
          </span>
        );
      }

      // Always show last page
      buttons.push(
        <button
          key="last"
          className={`pagination-button ${currentPage === totalPages ? "active" : ""
            }`}
          onClick={() => handlePageChange(totalPages)}>
          {totalPages}
        </button>
      );
    } else {
      // Less than 7 pages, show all page buttons
      for (let i = 2; i <= totalPages; i++) {
        buttons.push(
          <button
            key={i}
            className={`pagination-button ${currentPage === i ? "active" : ""}`}
            onClick={() => handlePageChange(i)}>
            {i}
          </button>
        );
      }
    }

    return buttons;
  };
  // ************************************************************eND of PAgination functionality********************************************************************//


  // Fetch project statistics
  const fetchProjectStats = async () => {
    setStatsLoading(true)
    try {
      const response = await axios.get(
        `${BASE_URL_PREBID}/project/projectfilterbyprojectstatusnew/${toggleStatus}/${role === "HOD" ? "null" : emp_code}/null/${currentPage}/${itemsPerPage}/${minCost}/${maxCost}/null/null/`
      );
      setProjectStats(response.data)
    } catch (error) {
      console.error("Error fetching project stats:", error)
      handleErrorToast(error)
    } finally {
      setStatsLoading(false)
    }
  }

  useEffect(() => {
    const compareFunction = (a, b) => {
      const valA = a.prebid_prcode || ""
      const valB = b.prebid_prcode || ""
      const valM = a.project_short_name || ""
      const valN = b.project_short_name || ""

      if (sorting === "asc_pr") {
        return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: "base" })
      } else if (sorting === "desc_pr") {
        return valB.localeCompare(valA, undefined, { numeric: true, sensitivity: "base" })
      } else if (sorting === "asc_short_name") {
        if (!valM && valN) return 1
        if (valM && !valN) return -1
        return valM.localeCompare(valN, undefined, { sensitivity: "base" })
      } else if (sorting === "desc_short_name") {
        if (!valM && valN) return -1
        if (valM && !valN) return 1
        return valN.localeCompare(valM, undefined, { sensitivity: "base" })
      }
    }

    setSortedData(sortedData)
  }, [sorting, allProjectssData])

  const emp_code = sessionStorage.getItem("employee_id")
  const role = sessionStorage.getItem("role")
  const department = sessionStorage.getItem("department")
  const pr_project = sessionStorage.getItem("pr_project")

  const getProjectData = async () => {
    setBuffering(true)
    try {
      const res = await axios.get(
        `${BASE_URL_PREBID}/project/projectfilterbyprojectstatusnew/${toggleStatus}/${role === "HOD" ? "null" : emp_code}/null/${currentPage}/${itemsPerPage}/${minCost}/${maxCost}/${project}/null/`
      );
      setAllProjectsData(res.data)
      setResultdata(res.data.count);
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setBuffering(false)
    }
  }

  useEffect(() => {
    getProjectData()
    fetchProjectStats() // Fetch stats when component mounts
  }, [toggleStatus, emp_code, currentPage, itemsPerPage, minCost, maxCost, project])

  const navigate = useNavigate()

  const currentUrl = window.location.href
  const urlParts = currentUrl.split("/")
  const associated = true

  const ViewAllProjectDetails = (projectID) => {
    navigate(`/${urlParts[3]}/projectDetailsPage/`, {
      state: { projectID, associated },
    })
  }

  const handleSearch = () => {
    let filteredingData = allProjectssData.result;

    if (search1 !== "") {
      const lowercasesearch1 = search1?.toString().toLowerCase()
      filteredingData = filteredingData?.filter((employee) => {
        const codeMatch = employee?.prebid_prcode?.toString().toLowerCase().includes(lowercasesearch1.toLowerCase())

        const projectMatch = employee?.project_name?.toString().toLowerCase().includes(lowercasesearch1.toLowerCase())

        const shortProjectMatch = employee?.project_short_name
          ?.toString()
          .toLowerCase()
          .includes(lowercasesearch1.toLowerCase())
        return codeMatch || projectMatch || shortProjectMatch
      })
    }
    setSortedData(filteredingData)
  }

  useEffect(() => {
    handleSearch()
  }, [search1])

  // Prepare status bar data
  const statusBarData = [
    { title: "Total Projects", label: projectStats.total_projects, value: "total" },
    { title: "Completed", label: projectStats.completed, value: "completed" },
    { title: "Pending", label: projectStats.pending, value: "pending" },
    { title: "In Progress", label: projectStats.in_progress, value: "in_progress" },
    { title: "Hold", label: projectStats.hold, value: "hold" },
    { title: "Cancelled", label: projectStats.cancelled, value: "cancelled" },
  ]

  const handleStatusCardClick = (value) => {
    // Handle status card click if needed
    console.log("Status card clicked:", value)
  }

  const [stats, setStats] = useState({
    data: [],
    loading: false,
  });

  const getProjectStats = async () => {
    setStats((prev) => ({ ...prev, loading: true }));
    try {
      const res = await axios.get(
        `${BASE_URL_PREBID}/project/projectstats/`
      );
      setStats((prev) => ({ ...prev, data: res.data }));
    } catch (err) {
      handleErrorToast(err)
    } finally {
      setStats((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    getProjectStats();
  }, []);

  const handleStatClick = (value) => {
    setToggleStatus(value);
  };

  useEffect(() => {
    if (minCost === "") {
      setMinCost("null");
    }
    if (maxCost === "") {
      setMaxCost("null");
    }
  }, [minCost, maxCost])



  return (
    <>
      <Dashboardnavbarcopy url="Projects Management" name={"Associated Projects"} />

      <div className="content-tabs">
        <div className="attendance-subcont">
          <div className="field-cont">
            {pr_project === "true" ? (
              <div title="Project Filter " className="field-cont-div ">
                <CircularGrid />
                <select
                  value={prProjects}
                  onChange={(e) => setPrProjects(e.target.value)}
                  className={`attendance-input-field width-15vw`}
                >
                  <option value="null">Select Project Type</option>
                  <option value="false">Projects</option>
                  <option value="true">PR Projects</option>
                </select>
                <hr className="field-cont-hr" />
              </div>
            ) : null}

            <div title="Sort Filter" className="field-cont-div">
              <Sort />
              <select
                className="attendance-input-field width-15vw date-field"
                type="text"
                value={sorting}
                onChange={handleSortChange}
              >
                <option value="asc_pr">Asc. Project Code</option>
                <option value="desc_pr">Desc. Project Code</option>
                <option value="asc_short_name">Asc. Project Name</option>
                <option value="desc_short_name">Desc. Project Name</option>
              </select>
              <hr className="field-cont-hr" />
            </div>

            <div title="Status Filter" className="field-cont-div">
              <Filter />
              <select
                className="attendance-input-field width-15vw date-field"
                value={toggleStatus}
                onChange={handleStatusChange}
              >
                <option value="null">All Projects</option>
                <option value="inprogress">In Progress</option>
                <option value="completed">Completed</option>
                <option value="pending">Pending</option>
                <option value="hold">Hold</option>
                <option value="cancelled">Cancelled</option>
              </select>
              <hr className="field-cont-hr" />
            </div>


            <Projectname projectName={project} setProjectName={SetProject} assignTO={emp_code} />

            <div className="field-cont-div" >
              <SearchBig />
              <input
                className="attendance-input-field"
                style={{ width: "8vw" }}
                placeholder="Min Cost"
                value={minCost}
                type="number"
                onChange={(e) => setMinCost(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>

            <div className="field-cont-div" >
              <SearchBig />
              <input
                className="attendance-input-field"
                style={{ width: "8vw" }}
                placeholder="Max Cost"
                value={maxCost}
                type="number"
                onChange={(e) => setMaxCost(e.target.value)}
              />
              <hr className="field-cont-hr" />
            </div>
          </div>

          <div className="btn-cont">
            <UploadProjectsBulk getProject={getProjectData} />
          </div>
        </div>

        {/* {role === 'Employee' && department === 'Accounts' ? null : <StatsBar onClick={handleStatClick} data={stats.data} status={toggleStatus} />} */}
        <div className="flex-row justify-end">
          Showing{" "}
          {Math.min((currentPage - 1) * itemsPerPage + 1, resultData)} -{" "}
          {Math.min(currentPage * itemsPerPage, resultData)} of{" "}
          {resultData} records
        </div>

        <div className="attendance-box">
          <div className="datagrid-container">
            <div className="custom-table-background height-73vh" style={{ padding: "20px 0 0 0" }}>
              <div className="table-heading-flex">
                {/* <div className="repo-heading font-size-heading font-weight500">All Projects</div> */}
              </div>

              <div className="table-box scroll-container-table">
                <table className="custom-table">
                  <thead className="table-heading">
                    <tr className="custom-table-head-trr">
                      <th className="table-heading-text justify-center">Sr.</th>
                      <th className="table-heading-text text-center">Project Code</th>
                      <th className="table-heading-text width-5vw">Project Name</th>
                      <th className="table-heading-text ">Cost (in cr)</th>
                      <th className="table-heading-text ">Concern Person</th>
                      <th className="table-heading-text ">Portal Submission Date</th>
                      <th className="table-heading-text ">Tender ID</th>
                      <th className="table-heading-text ">Remark</th>
                      <th className="table-heading-text text-center">Project Link</th>
                      <th className="table-heading-text text-center">
                        Client Details
                        <td
                          className="padding-bottom-5px "
                          style={{ display: "flex", justifyContent: "space-around", paddingTop: "20px" }}
                        >
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            Client Name
                          </td>
                          <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
                            <hr className="field-cont-hr" />
                          </th>
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            WO Date
                          </td>
                          <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
                            <hr className="field-cont-hr" />
                          </th>
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            Target Date
                          </td>
                          <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
                            <hr className="field-cont-hr" />
                          </th>
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            Due Date
                          </td>
                          <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
                            <hr className="field-cont-hr" />
                          </th>
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            Status
                          </td>
                          <th className="justify-center align-center" style={{ padding: "0px 4px" }}>
                            <hr className="field-cont-hr" />
                          </th>
                          <td className="padding-bottom-5px word-wrap-5vw justify-center align-center text-center">
                            Progress
                          </td>
                        </td>
                      </th>
                      <th className="table-heading-text text-right align-center  ">Action</th>
                    </tr>
                  </thead>

                  {buffer ? (
                    <div className="loader">
                      <div className="truckWrapper">
                        <div className="truckBody">
                          <Truckbody />
                        </div>
                        <div className="truckTires">
                          <Tires />
                          <Tires />
                        </div>
                        <div className="road"></div>
                        <Road />
                      </div>
                    </div>
                  ) : (
                    <tbody>
                      {allProjectssData?.results?.map((i, index) => (
                        <React.Fragment key={index}>
                          <tr className="tr-border-bottom">
                            <td colSpan="8"></td>
                          </tr>
                          <tr className="custom-table-head-tddd font-size-label font-weight500">
                            <td className="table-body-text">{(currentPage - 1) * itemsPerPage + index + 1}.</td>

                            <td className="table-body-text">{i.prebid_prcode}</td>
                            <td className="table-body-text word-wrap-10vw">{i.project_short_name}</td>
                            <td className="table-body-text">{formatRoundoffCrores(i.cost)}</td>
                            <td className="table-body-text">
                              {i.concern_person_name === "null" ? "-" : i.concern_person_name}
                            </td>
                            <td className="table-body-text">
                              {i.portal_submission_date === null ? "" : formattedDateLong(i.portal_submission_date)}
                            </td>
                            <td className="table-body-text">{i.tender_id}</td>
                            <td className="table-body-text">{i.remark === "null" ? "-" : i.remark}</td>
                            <td className="table-body-text align-center">
                              {i.link ? (
                                <a href={i.link} target="blank" className="width-5vw">
                                  <Attachment />
                                </a>
                              ) : (
                                <>-</>
                              )}
                            </td>

                            {/* Rest of your existing table content remains the same */}
                            {prProjects !== "null" ? (
                              <td className="table-body-text">{/* Your existing client details rendering logic */}</td>
                            ) : (
                              <td className="table-body-text">{/* Your existing client details rendering logic */}</td>
                            )}

                            <td className="text-end align-end flex-row-ar">
                              <button
                                title="View Project Detail Page"
                                className=""
                                onClick={(e) => ViewAllProjectDetails(i.pr_code)}
                              >
                                <Eye />
                              </button>
                              {role === "HOD" ? (
                                <DeleteProjectDetails i={i} getProjects={getProjectData} prProjects={prProjects} />
                              ) : null}

                              <UpdateProjectDetaiils
                                id={project.pr_code}
                                modalData={i}
                                allEmployeeData={allEmployeeData}
                                getProjectDetails={getProjectData}
                                useFor="form"
                              />
                            </td>
                          </tr>
                        </React.Fragment>
                      ))}
                    </tbody>
                  )}
                </table>
              </div>
            </div>
            {totalPages > 1 && (
              <div className="pagination-controls">
                <button
                  className="pagination-nav-button"
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <polyline points="15 18 9 12 15 6"></polyline>
                  </svg>
                  Prev
                </button>

                <div className="pagination-buttons">
                  {renderPaginationButtons()}
                </div>

                <button
                  className="pagination-nav-button"
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  Next
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default AllProjectDetails;